import { getDeep } from '@shared/utils';
import PIEVE_ONBOARDING_FINISHED_PREF_KEY from '@/lib/prefs/PIEVE_ONBOARDING_FINISHED_PREF_KEY.js';

/** Whether the signed-in person finished (or skipped) first-run setup, from their saved preferences. */
export const hasFinishedOnboarding = (state) => getDeep(PIEVE_ONBOARDING_FINISHED_PREF_KEY, state?.ui?.prefs || {}) === true;
